// import Brochure from "../../asset/pdf/Dubai_Brochure.pdf";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

const b1 = imageBaseUrl + "immigrationbenefit/benefit1.png";
const b2 = imageBaseUrl + "immigrationbenefit/benefit2.png";
const b3 = imageBaseUrl + "immigrationbenefit/benefit3.png";
const b4 = imageBaseUrl + "immigrationbenefit/benefit4.png";
const b5 = imageBaseUrl + "immigrationbenefit/benefit5.png";
const b6 = imageBaseUrl + "immigrationbenefit/benefit6.png";
const b7 = imageBaseUrl + "immigrationbenefit/benefit7.png";
const b8 = imageBaseUrl + "immigrationbenefit/benefit8.png";

const MiddleEastImmersionObjectives = {
  Dubai: [
    {
      title:
        "Conceptualize, develop, and present an AI-based business solution as part of the Dubai Business Challenge",
      img: b1,
    },
    {
      title:
        "Learn critical business skills for engineers – strategy, leadership, people management, communication, and business development.",
      img: b2,
    },
    {
      title:
        "Prepare for international career opportunities and working abroad.",
      img: b3,
    },
    {
      title:
        "Develop adaptability and cross-cultural intelligence to effectively manage and thrive in diverse international work environments.",
      img: b4,
    },
  ],
};

const SouthEastAsiaImmersionObjectives = {
  Malaysia: [
    {
      title:
        "Expand your knowledge: Gain insights into global technological advancements and their real-world applications.",
      img: b1,
    },
    {
      title:
        "Develop skills for the future: Enhance critical thinking, problem-solving, and adaptability by experiencing diverse learning environments.",
      img: b2,
    },
    {
      title:
        "Build global connections: Establish networks with students and professionals from various disciplines and countries.",
      img: b3,
    },
    {
      title:
        "Cultural immersion: Explore the rich multicultural heritage of Malaysia through structured excursions.",
      img: b4,
    },
  ],
  Thailand: [
    {
      title: "Interactive Seminars on Trending Courses and Topics on AI",
      img: b5,
    },
    {
      title: "Cultural, Social Awareness, and Appreciation of New Cultures",
      img: b6,
    },
    {
      title:
        "Interaction with World-Class Professors, Corporate Executives, and Research Experts in respective fields",
      img: b7,
    },
    {
      title: "Explore Career and Higher Education Opportunities",
      img: b8,
    },
  ],
};

const EuropeImmersionObjectives = {
  France: [
    {
      title:
        "Conceptualize, develop, and present an AI-based business solution as part of the French Business Challenge.",
      img: b1,
    },
    {
      title:
        "Learn critical business skills for engineers – strategy, leadership, people management, communication, and business development and all these leading to inter-disciplinary learning.",
      img: b2,
    },
    {
      title:
        "Prepare for international career opportunities and working abroad.Develop adaptability and cross-cultural intelligence to effectively manage and thrive in diverse international work environments.",
      img: b3,
    },
  ],
  Germany: [
    {
      title:
        "Conceptualize, develop, and present an AI-based business solution as part of the Business Challenge.",
      img: b1,
    },
    {
      title: "Learn critical business skills for engineers – strategy, leadership, people management, communication, and business development and all these leading to inter-disciplinary learning.",
      img: b2,
    },
    {
      title: "Prepare for international career opportunities and working abroad.",
      img: b3,
    },
    {
      title: "Develop adaptability and cross-cultural intelligence to effectively manage and thrive in diverse international work environments.",
      img: b4,
    },
  ],
};

const NorthAmericaImmersionObjectives = {
  North: [
    {
      title:
        "Gain insights into the North American business and startup ecosystem.",
      img: b1,
    },
    {
      title: "Understand key economic trends and innovation-driven markets.",
      img: b2,
    },
    {
      title: "Develop a global mindset for working in competitive industries.",
      img: b3,
    },
  ],
};

export {
  MiddleEastImmersionObjectives,
  SouthEastAsiaImmersionObjectives,
  EuropeImmersionObjectives,
  NorthAmericaImmersionObjectives,
};
